import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { environment } from 'apps/app-cic-ciam/src/environments/environment';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { UsernameState } from '../../store';

@Component({
  selector: 'digitsolu-forgot-username-submit',
  templateUrl: './forgot-username-submit.component.html',
  styleUrls: ['./forgot-username-submit.component.scss'],
})
export class ForgotUsernameSubmitComponent {
  // userInfo$: Signal<
  //   | {
  //       email?: string | null;
  //       phone?: string | null;
  //     }
  //   | null
  //   | undefined
  // > = toSignal(this.store.select(UsernameState.getUserInfo));
  userInfo$: Observable<
    | {
        email?: string | null;
        phone?: string | null;
      }
    | null
    | undefined
  > = this.store.select(UsernameState.getUserInfo);

  // userInfo = computed(() => {
  //   return this.userInfo$();
  // });

  get supportNumber(): string {
    return environment.supportNo;
  }

  constructor(
    private router: Router,
    private store: Store,
    // private readonly translate: TranslateService,
    private supportService: SupportService,
    private toastr: ToastrService
  ) {}

  goToLogin($event: any) {
    $event.preventDefault();
    // this.router.navigate(['/portallogin']);
    window.close();
  }

  // async sendUsername() {}
}
